module.exports = __webpack_public_path__ + "static/media/MHSB168.58461932.png";